import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';

import { VonageSubAccountNumber } from './models';

const WHATSAPP_VONAGE_ENDPOINT_PATH = 'whatsapp-via-vonage';

@Injectable({
  providedIn: 'root',
})
export class WhatsappAccountVonageService {
  constructor(
    private alcmeonContext: AlcmeonContextService,
    private errorHandlingService: ErrorHandlingService,
    private http: HttpClient,
    @Inject('sites') private sites: any,
    @Inject('sitesMap') private sitesMap: any
  ) {}

  getWhatsAppVonageAccountNumbers(): Observable<VonageSubAccountNumber[]> {
    const url = `${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/${WHATSAPP_VONAGE_ENDPOINT_PATH}/list`;
    return this.http.get<VonageSubAccountNumber[]>(url).pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  connectWhatsAppVonageNumber = (vonageSubAccountNumber: VonageSubAccountNumber): Observable<number> => {
    const url = `${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/${WHATSAPP_VONAGE_ENDPOINT_PATH}/register`;
    return this.http.post<number>(url, vonageSubAccountNumber).pipe(
      this.errorHandlingService.catchAlertAndThrowHttpError(),
      tap(() => this.sites.refresh().then(() => this.sitesMap.refresh()))
    );
  };
}
